import React from 'react';
import MethodsCatalogueTable from './MethodsCatalogueTable';
import CreateWithdrawMethodModal from './CreateWithdrawMethodModal';

interface WithdrawMethodsTableProps {
  siteId: string | number;
}

const WithdrawMethodsTable: React.FC<WithdrawMethodsTableProps> = ({ siteId }) => (
  <MethodsCatalogueTable
    siteId={siteId}
    direction="withdraw"
    CreateModal={CreateWithdrawMethodModal}
  />
);

export default WithdrawMethodsTable;
